import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Flame, Star } from "lucide-react";
import { inr } from "@/lib/api";
import ImageSlideshow, { getImages } from "@/components/ImageSlideshow";

export const TAG_META = {
  veg: { label: "Veg", icon: Leaf, cls: "bg-biga-green text-biga-cream" },
  spicy: { label: "Spicy", icon: Flame, cls: "bg-biga-orange text-biga-cream" },
  chef_special: { label: "Signature", icon: Star, cls: "bg-biga-ink text-biga-cream" },
};

export default function ItemMedia({ item, interactive }) {
  const available = item.available !== false;
  const isDip = item.category === "dips" && getImages(item).length === 0;
  const isPizza = item.category === "roman";
  const accent = item.accent || null;
  const visibleTags = item.tags.filter((tag) => tag !== "veg");
  return (
      <div className="relative aspect-[4/3] overflow-hidden" style={isDip && accent ? { backgroundColor: accent } : undefined}>
        {isDip && accent ? (
          <div className="w-full h-full flex items-center justify-center relative" style={{ background: `linear-gradient(135deg, ${accent} 0%, ${accent}dd 60%, ${accent}88 100%)` }}>
            <span className="font-display font-black text-5xl sm:text-6xl text-white/95 drop-shadow-[0_4px_20px_rgba(0,0,0,0.25)] tracking-tight uppercase leading-none px-4 text-center">
              {item.name.split(" ")[0]}
            </span>
          </div>
        ) : (
          <ImageSlideshow
            images={getImages(item)}
            alt={item.name}
            className={interactive ? "group-hover:scale-[1.02] transition-transform duration-700" : "grayscale"}
          />
        )}
        <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap">
          <span className={`w-5 h-5 rounded-sm border-2 flex items-center justify-center bg-white/90 ${item.veg === "egg" ? "border-amber-500" : item.veg ? "border-biga-green" : "border-red-600"}`}>
            <span className={`w-2.5 h-2.5 rounded-full ${item.veg === "egg" ? "bg-amber-500" : item.veg ? "bg-biga-green" : "bg-red-600"}`} />
          </span>
        </div>
        {!available && (
          <div className="absolute inset-0 bg-biga-ink/55 flex items-center justify-center" data-testid={`sold-out-${item.id}`}>
            <span className="bg-biga-cream text-biga-ink font-display font-black text-xl px-5 py-2 rounded-full border-2 border-biga-ink -rotate-6 shadow-xl">Sold out</span>
          </div>
        )}
        {item.original_price && (
          <span className="absolute top-3 right-3 bg-biga-orange text-biga-cream text-xs font-black uppercase tracking-wide px-2.5 py-1 rounded-full" data-testid={`save-badge-${item.id}`}>
            Save {inr(item.original_price - item.price)}
          </span>
        )}
        <div className="absolute bottom-3 left-3 flex gap-1.5 flex-wrap">
          {visibleTags.map((t) => {
            const m = TAG_META[t];
            if (!m) return null;
            const Icon = m.icon;
            return (
              <span key={t} className={`flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full ${m.cls}`}>
                <Icon size={11} /> {m.label}
              </span>
            );
          })}
        </div>
        {isPizza && (
          <Link to={`/pizza/${item.id}`} data-testid={`view-item-${item.id}`} aria-label={`View ${item.name} details`} className="absolute inset-0 z-[1]" />
        )}
      </div>
  );
}
